import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { gtm } from 'apps/gtm';
import { wa, pageEventTypes } from 'apps/analytics';
import { requestLogin } from 'utils/loginAndRegistration/login';

export default class ShoppingListsButton extends PureComponent {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    onShoppingListsModalOpen: PropTypes.func,
    openShoppingListsModal: PropTypes.func.isRequired,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
    }).isRequired,
    router: PropTypes.object.isRequired,
  };

  handleLoggedOut = () => {
    const { router } = this.props;

    requestLogin(router);
  }

  open = () => {
    if (!this.props.isLoggedIn) {
      this.handleLoggedOut();
    }

    this.props.openShoppingListsModal(this.props.product);

    gtm.trigger('gtm:uaEvent', {
      category: 'Shopping List',
      action: 'Add to Shopping lists popup opened',
    });
    wa.triggerPageEvent(pageEventTypes.QM_OPEN_SHOPPING_LIST_POPUP);

    if (typeof this.props.onShoppingListsModalOpen === 'function') {
      this.props.onShoppingListsModalOpen();
    }
  };

  render() {
    return (
      <button className="fop-quickMenu__options--tileAction" type="button" onClick={this.open}>
        <span className="fop-quickMenu__options--tileShoppingLists" />
        <span className="fop-quickMenu__options--tileLabel">Add to list</span>
      </button>
    );
  }
}
